import script from "./users.vue?vue&type=script&setup=true&lang=ts"
export * from "./users.vue?vue&type=script&setup=true&lang=ts"

import "./users.vue?vue&type=style&index=0&id=2b03bfc1&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b03bfc1"]])

export default __exports__